import {AUTH_LOAD_COMPANY_BILLING_INFO, AUTH_LOGGED_IN} from "@/store/modules/auth/actions";
import CompanyService from "@/services/company.service";
import Moment from 'moment'
import EventBus from '@/eventbus/global.event.bus'
import {EVENT_AUTH_LOGGED_IN} from "@/eventbus/events";
import {KORZINKA_INN} from "@/settings";

export default {
    state: {
        login: null,
        billing: {
            balance: 0,
            creditBalance: 0,
            creditLimit: 0,
            isCreditActive: false,
            isTrialActive: false,
            trialPeriodDaysLeft: 0,
            trialStart: null,
            isLoading: false
        }
    },
    getters: {
        login: (state) => {
            return state.login;
        },
        companyInn(state) {
            return state.login ? state.login.company.inn : null;
        },
        billing(state) {
            return state.billing
        },
        isKorzinkaLogin(state) {
            return state.login && state.login.company.inn === KORZINKA_INN;
        }
    },
    mutations: {
        storeLogin(state, login) {
            state.login = login;
        },
        clearLogin(state) {
            state.login = null;
        },
        setBillingLoading(state, isLoading) {
            state.billing.isLoading = isLoading
        },
        setBilling(state, {balance, creditBalance, creditLimit, isCreditActive, isTrialActive, trialPeriodDaysLeft, trialStart}) {
            state.billing.balance = balance
            state.billing.creditBalance = creditBalance
            state.billing.creditLimit = creditLimit
            state.billing.isCreditActive = isCreditActive
            state.billing.isTrialActive = isTrialActive
            state.billing.trialPeriodDaysLeft = trialPeriodDaysLeft
            state.billing.trialStart = trialStart
        }
    },
    actions: {
        [AUTH_LOAD_COMPANY_BILLING_INFO]: ({commit}) => {
            commit("setBillingLoading", true)
            CompanyService.getBillingInfo()
                .then(response => {
                    commit("setBilling", {
                        balance: response.data.Balance,
                        creditBalance: response.data.CreditBalance,
                        creditLimit: response.data.CreditLimit,
                        isCreditActive: response.data.IsCreditActive,
                        isTrialActive: response.data.IsTrialActive,
                        trialPeriodDaysLeft: response.data.TrialPeriodDaysLeft,
                        trialStart: response.data.TrialStart ? Moment(response.data.TrialStart) : null
                    })
                })
                .catch(() => {

                })
                .finally(() => {
                    commit("setBillingLoading", false)

                })
        },
        [AUTH_LOGGED_IN]: ({commit}, login) => {
            commit('storeLogin', login)
            EventBus.$emit(EVENT_AUTH_LOGGED_IN)
        }
    },

}